export default class DeleteFile extends HTMLButtonElement {

    connectedCallback() {

        this.addEventListener("click", this.handleClick);

    }

    disconnectedCallback() {

        this.removeEventListener("click", this.handleClick);

    }

    handleClick = (e) => {
        e.preventDefault();

        if (this.deleteFileElement != null && this.displayElement) {
            let currentFiles = new Set();

            if (this.deleteFileElement.value) {
                currentFiles = new Set(this.deleteFileElement.value.split(","));
            }

            currentFiles.add(this.fileId);

            this.deleteFileElement.value = Array.from(currentFiles).join(",");
        }

        if (this.displayElement) {
            this.displayElement.remove();
        }
    }

    get fileId() {
        return this.dataset.deletefileId;
    }

    get displayElement() {
        return document.querySelector("#" + this.dataset.deletefileDisplay);
    }

    get deleteFileElement() {
        return document.querySelector("#" + this.dataset.deletefileElement);
    }

}

customElements.define('delete-file', DeleteFile, { extends: 'button' });